import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LETTERS } from "./quipState";
import { Scramble } from "./LogText";

const ROWS = ["QWERTYUIOP", "ASDFGHJKL", "ZXCVBNM"];
const CONSENT = "This is my own face. I agree to its use in this game, including processing by third-party services to create my personalized images and video. Deleted on request.";

// The ciphertext, word gaps kept; a blank under each letter. Tap a letter to select every instance of it.
export function QuipBoard({ cipher, known, selected, glow, onSelect, solved }) {
  let i = -1;
  return (
    <div data-testid="quip-board" className={`flex flex-wrap justify-center gap-x-5 gap-y-5 ${solved ? "quip-solved-flash" : ""}`}>
      {cipher.split(" ").map((word, wi) => (
        <div key={wi} className="flex gap-1">
          {Array.from(word).map((c) => {
            i += 1;
            const letter = LETTERS.includes(c);
            const sel = letter && c === selected && !solved;
            return (
              <button key={i} type="button" disabled={!letter || solved} onClick={() => onSelect(c)} data-testid={`quip-cell-${i}`}
                data-cipher={c} data-selected={sel ? "1" : undefined}
                className={`quip-cell flex w-[1.35rem] flex-col items-center sm:w-8 ${sel ? "quip-cell-sel" : ""} ${glow === c ? "quip-glow" : ""}`}>
                <span className="text-base sm:text-2xl text-[color:var(--w1-amber)]">{c}</span>
                <span data-testid={`quip-slot-${i}`} className="quip-blank mt-1 flex h-7 w-full items-end justify-center border-b-2 text-base sm:h-9 sm:text-2xl">
                  {letter ? known[c] || "" : ""}
                </span>
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}

export function QuipKeys({ used, onKey }) {
  return (
    <div className="space-y-1.5 pb-2 pt-6" data-testid="quip-keyboard">
      {ROWS.map((row) => (
        <div key={row} className="flex justify-center gap-1">
          {Array.from(row).map((k) => (
            <button key={k} type="button" onClick={() => onKey(k)} data-testid={`quip-key-${k}`}
              className={`quip-key h-12 min-w-0 max-w-[46px] flex-1 border text-sm sm:h-14 ${used.has(k) ? "opacity-35" : ""}`}>{k}</button>
          ))}
        </div>
      ))}
    </div>
  );
}

export function TraceBanner({ phase }) {
  if (phase === "none") return null;
  return (
    <>
      {phase === "trace" && <div data-testid="quip-trace-complete" className="quip-trace">TRACE COMPLETE</div>}
      {phase === "banner" && (
        <div data-testid="quip-helpers-banner" className="helpers-banner helpers-in"><span className="helpers-text">Tidying up for you ♡</span></div>
      )}
    </>
  );
}

export function QuipSolved({ text, email }) {
  const [show, setShow] = useState(false);
  useEffect(() => { const id = setTimeout(() => setShow(true), 3000); return () => clearTimeout(id); }, []);
  if (!show) return null;
  return (
    <div data-testid="quip-solved-panel" className="mt-10">
      <p data-testid="quip-m-line" className="text-center text-sm tracking-[0.08em] text-[color:var(--w1-amber)] sm:text-base"><Scramble text={text} ms={1400} /></p>
      <Consent email={email} />
    </div>
  );
}

function Consent({ email }) {
  const [age, setAge] = useState(false);
  const [consent, setConsent] = useState(false);
  const ready = age && consent;
  return (
    <div className="w1-fade-in mx-auto mt-8 max-w-xl border border-[color:var(--w1-border)] bg-[color:var(--w1-surface)] p-5 text-[color:var(--w1-text)]">
      <label className="flex cursor-pointer items-start gap-3 text-xs leading-6">
        <input type="checkbox" data-testid="cipher-18plus-checkbox" checked={age} onChange={(e) => setAge(e.target.checked)} className="mt-1 h-5 w-5 shrink-0 accent-[#ffb000]" />
        <span>I am 18 or older.</span>
      </label>
      <label className="mt-3 flex cursor-pointer items-start gap-3 text-xs leading-6">
        <input type="checkbox" data-testid="cipher-consent-checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-1 h-5 w-5 shrink-0 accent-[#ffb000]" />
        <span data-testid="cipher-consent-text">{CONSENT}</span>
      </label>
      <Link to="/privacy" data-testid="cipher-privacy-link" className="mt-3 inline-block text-[11px] text-[color:var(--w1-muted)] underline">Privacy policy</Link>
      <a href={ready ? `mailto:${email}?subject=${encodeURIComponent("my face — 18+, i consent")}` : undefined}
        data-testid="cipher-reply-button" aria-disabled={!ready}
        className={`mt-6 flex h-14 items-center justify-center border text-xs tracking-[0.35em] transition-colors ${ready ? "border-[color:var(--w1-amber)] text-[color:var(--w1-amber)] hover:bg-[color:var(--w1-amber)] hover:text-black" : "pointer-events-none border-[color:var(--w1-border)] text-[color:var(--w1-muted)]"}`}>
        REPLY TO M
      </a>
    </div>
  );
}
